<template>
    <div class="container">
        <!-- <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220505/1651731649259.png" alt="">
        </div> -->
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220510/1652162334132.jpg" alt="">
        </div>
        <!-- <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220509/1652083804061.jpg" alt="">
        </div> -->
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220505/1651731687086.png" alt="">
            <div class="lesson-container">
                <div v-for="(course, index) in courseList" :key="index" class="lesson-list">
                    <div v-for="item in course" :key="item.decorateId" class="lesson-item" @click="handleCourseClick(item)">
                        <img class="lesson-img" :src="item.image">
                        <div class="lesson-content">
                            <div class="lesson-title">{{ item.title }}</div>
                            <div class="lesson-labs">
                                <div class="lesson-lab">{{ item.teacherName }}</div>
                                <div class="lesson-tips">{{ item.teacherTitle  }}</div>
                            </div>
                            <div class="lesson-price"><div class="i">￥</div><div class="price">{{ item.price }}</div> {{ item.pruchasedCount }}人订阅</div>
                        </div>
                    </div>
                </div>
            </div>
            <img class="invite" @click="inviteFn" src="https://s20.lgstatic.com/growth/activity/20220505/1651732123793.png" alt="">
            <div class="record" @click="showRecordModal">查看邀请记录</div>
        </div>
        <commonCom />
        <div v-if="recordListVisible" class="invite-modal">
            <div class="invite-modal-content">
                <img class="modal-colse" @click="recordListVisible = false" src="https://s20.lgstatic.com/growth/activity/20220506/1651819530784.png" alt="">
                <div class="invite-modal-head">邀请记录</div>
                <div class="invite-record-wrap">
                    <div v-if="inviteRecords.length" class="invite-record-list">
                        <div v-for="record in inviteRecords" :key="record.userId" class="invite-record-item">
                            <div class="record-item-left">
                                <img class="avatar" :src="record.headPicUrl" alt="">
                                <div class="user-info">
                                    <div class="user-name">{{ record.userName }}</div>
                                    <div class="time">{{ record.time }}</div>
                                </div>
                            </div>
                            <div class="record-item-right">
                                <img v-if="record.type == 0" class="seven" src="https://s20.lgstatic.com/growth/activity/20220506/1651820092897.png" alt="">
                                <img v-else class="seven two" src="https://s21.lgstatic.com/growth/activity/20220511/1652251551923.png" alt="">
                            </div>
                        </div>
                        <div class="no-more">没有更多了</div>
                    </div>
                    <div v-else class="no-data">暂无邀请记录</div>
                </div>
            </div>
        </div>
        <div v-if="copyVisible" class="copy-modal">
            <div class="copy-modal-content">
                <img class="modal-colse" @click="copyVisible = false" src="https://s20.lgstatic.com/growth/activity/20220506/1651819530784.png" alt="">
                复制成功，分享到微信好友
            </div>
        </div>
        <div v-if="wxVisible" class="wx-modal">
            <img class="wx-modal-img" @click="wxVisible = false" src="https://s21.lgstatic.com/growth/activity/20220512/1652336135528.png" alt="">
        </div>
    </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import { Toast } from 'vant';
import { getCourseList, getInviteRecords, getShareUrl } from '../../../service/api'
import { enableAppShare } from '../../../common/js/APP/share';
import { Clipboard } from '../../../uitl/copy';
import commonCom from './commonCom.vue';
import data from './data.js';
import share from '../../../common/js/share';
export default {
    components: {
        commonCom
    },
    data() {
        return {
            recordListVisible: false,
            copyVisible: false,
            wxVisible: false,
            courseList: [],
            inviteRecords: [],
            shareUrl: "",
            shareData: {
                title: '5月告白季狂送好礼，快来领取>>',
                desc: '最高70天会员免费领、求职技能包限量送，进入会场领取甜蜜好礼',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20220511/1652255266041.png'
            },
            list: data
        }
    },
    created () {
        if (this.isLogin() || this.isApp) {
            this.getShareUrl();
        }
        this.getCourseList()
    },
    methods: {
        initShare(shareUrl) {
            const shareMsg = {
                ...this.shareData,
                shareUrl: shareUrl || ''
            };
            share.init(shareMsg);
        },
        getCourseList() {
            this.courseList = this.filterCourseList(this.list);
            // getCourseList().then(res => {
            //     if (res.state == 1) {
            //         this.courseList = this.filterCourseList(res.content || []);
            //     } else {
            //         Toast(res.message);
            //     }
            // })
        },
        filterCourseList(courseList) {
            if (!courseList.length) return [];
            let record = [];
            const result = [];
            courseList.forEach((course, index) => {
                if (index % 3 == 0 && index !== 0) {
                    result.push(record);
                    record = [];
                    record.push(course);    
                } else {
                    record.push(course);
                }
            })
            return result;
        },
        getShareUrl() {
            getShareUrl().then(res => {
                if (res.state == 1) {
                    this.shareUrl = res.content || '';
                    console.log(res.content)
                    enableAppShare({
                        ...this.shareData,
                        shareUrl: res.content || ''
                    });
                    setTimeout(() => {
                        this.initShare(res.content);
                    }, 1000)
                } else {
                    Toast(res.message);
                }
            })
        },
        showRecordModal() {
            if (!this.isLogin()) {
                return window.open('/frontLogin.do', '_self');
            }
            getInviteRecords().then(res => {
                if (res.state == 1) {
                    this.inviteRecords = res.content || [];
                    this.recordListVisible = true;
                } else {
                    Toast(res.message);
                }
            })

        },
        inviteFn() {
            if (!this.isLogin()) {
                return window.open('/frontLogin.do', '_self');
            }
            if (this.isApp) {
                window.lgBridge && window.lgBridge.request('share', {
                    data: {
                        type: 'link',
                        channel: 'wechat_friends',
                        options: {
                            url: this.shareUrl,
                            desc: '最高70天会员免费领、求职技能包限量送，进入会场领取甜蜜好礼',
                            title: '5月告白季狂送好礼，快来领取>>',
                            thumb: 'https://s21.lgstatic.com/growth/activity/20220511/1652255266041.png'
                        }
                    },
                }, (res) => {
                    let { data = {} } = res;
                    if (data.state === 1) {
                        Toast('未安装微信');
                    }
                });
                return;
            }
            // 微信环境
            if (navigator.userAgent.indexOf('MicroMessenger') !== -1) {
                this.wxVisible = true;
            } else {
                return new Promise((resolve, reject) => {
                    try {
                        Clipboard().copy(this.shareUrl || '');
                        this.copyVisible = true;
                        resolve();
                    } catch (error) {
                        reject();
                    }
                });
            }
        },
        isLogin() {
            return Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token');
        },
        handleCourseClick(course) {
            window.location.href = course.h5Href;
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 144px;
}
.section {
    position: relative;
    display: flex;
    width: 100%;
    img {
        width: 100%;
    }
    .invite {
        position: absolute;
        left: 50%;
        bottom: 120px;
        width: 640px;
        height: 84px;
        transform: translateX(-50%);
    }
    .record {
        position: absolute;
        bottom: 70px;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 26px;
        color: #fff;
        font-style: italic;
        text-decoration: underline;
    }

}
.lesson-container {
    position: absolute;
    left: 62px;
    top: 404px;
    display: flex;
    width: 641px;
    height: 610px;
    padding: 17px 0 0 14px;
    box-sizing: border-box;
    overflow-x: auto;
}
.lesson-list {
    width: 497px;
    margin-right: 20px;
}
.lesson-item {
    display: flex;
    width: 497px;
    height: 177px;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    padding: 16px 18px 15px;
    box-sizing: border-box;
    .lesson-img {
        width: 109px;
        height: 146px;
    }
    .lesson-content {
        width: 332px;
        margin-left: 20px;
        .lesson-title {
            line-height: 32px;
            font-size: 32px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            white-space: nowrap;
            margin-bottom: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .lesson-desc {
            line-height: 24px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            margin-bottom: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .lesson-labs {
            display: flex;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #8C8C8C;
            line-height: 30px;
            .lesson-lab {
                background: #f8f9fa;
                border-radius: 2px;
                padding: 6px 10px;
                margin-right: 9px;
            }
            .lesson-tips {
                background: #f8f9fa;
                border-radius: 2px;
                padding: 6px 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .lesson-price {
            display: flex;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #7D7D7D;
            line-height: 24px;
            margin-top: 34px;
            .i {
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #EA4800;
            }
            .price {
                font-size: 32px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #EA4800;
                line-height: 18px;
                margin-right: 8px;
            }
        }
    }
}
.invite-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    .invite-modal-content {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 640px;
        height: 768px;
        background-color: #FF506D;
        border-radius: 10px;
        transform: translate(-50%, -50%);
    }
    .modal-colse {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 21px;
        height: 21px;
    }
    .invite-modal-head {
        width: 100%;
        height: 120px;
        line-height: 120px;
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
    }
    .invite-record-wrap {
        width: 100%;
        height: 630px;
        padding: 0 20px 0 23px;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .invite-record-list {
        border-radius: 5px;
        overflow: hidden;
        .invite-record-item {
            display: flex;
            height: 107px;
            padding: 20px 32px 18px 30px;
            box-sizing: border-box;
            background-color: #E54B64;
            justify-content: space-between;
            &:nth-child(2n) {
                background-color: #FF506D;
            }
        }
        .no-more {
            height: 107px;
            line-height: 107px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #820116;
            opacity: 0.5;
            text-align: center;
        }
    }
    .record-item-left {
        display: flex;
        width: 100%;
        .avatar {
            width: 69px;
            height: 69px;
            border-radius: 50%;
            background-color: #fff;
        }
        .user-info {
            margin-left: 22px;
            .user-name {
                font-size: 28px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 28px;
            }
            .time {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 24px;
                margin-top: 15px;
            }
        }
    }
    .record-item-right {
        .seven {
            width: 60px;
            height: 25px;
            &.two {
                width: 76px;
            }
        }
    }
    .no-data {
        text-align: center;
        font-size: 28px;
        color: #fff;
        margin-top: 100px;
    }
}
.copy-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    .copy-modal-content {
        position: absolute;
        top: 40%;
        left: 50%;
        width: 540px;
        height: 300px;
        line-height: 300px;
        text-align: center;
        color: #fff;
        font-size: 32px;
        background-color: #FF506D;
        border-radius: 10px;
        transform: translate(-50%, -50%);
    }
    .modal-colse {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 21px;
        height: 21px;
    }
}
.wx-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
    .wx-modal-img {
        width: 100%;
    }
}
</style>
